<button class="btn btn-primary" #findExistingCustomer id="findExistingCustomer" data-toggle="modal" data-target="#findExistingCustomerModal" (click)="getCustomers(0, 30)" hidden>{{ 'Buttons.SearchCustomer' | translate }}</button>

<div id="findExistingCustomerModal" class="modal fade" role="dialog">
    <div class="modal-dialog modal-xl mh-75" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{ 'Buttons.SearchCustomer' | translate }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 11L11 1M1 1L11 11" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg></button>
            </div>
            <div class="modal-body">
                <div class="w-100 mb-3">
                    <input type="text" class="form-control" placeholder="{{ 'Buttons.SearchCustomer' | translate }}" [(ngModel)]="customerSearchString" (keyup)="searchCustomers()">
                </div>
                <table id="customerTable" aria-label="Customer table" infinite-scroll [infiniteScrollDistance]="scrollDistance" [infiniteScrollUpDistance]="scrollUpDistance" [infiniteScrollThrottle]="throttle" [infiniteScrollContainer]="'#customerTableBody'" (scrolled)="onScrollDown()">
                    <thead>
                        <tr>
                            <th>{{ 'Standard.CustomerNumber' | translate }}</th>
                            <th>{{ 'Standard.Name' | translate }}</th>
                            <th>{{ 'Standard.Phone' | translate }}</th>
                            <th>{{ 'Standard.Mobile' | translate }}</th>
                            <th>{{ 'Standard.Address' | translate }}</th>
                            <th>{{ 'Standard.Email' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody id="customerTableBody">
                        <tr *ngFor="let x of shownCustomers; trackBy: trackById" (click)="chooseCustomer(x)" data-dismiss="modal">
                            <td>{{ x.customerNumber }}</td>
                            <td>{{ x.name }}</td>
                            <td>{{ x.customerPhone }}</td>
                            <td>{{ x.customerMobile }}</td>
                            <td>{{ x.customerAddress }}<span *ngIf="!!x.customerZipcode">, {{ x.customerZipcode }}</span><span *ngIf="!!x.customerCity"> {{ x.customerCity }}</span></td>
                            <td>{{ x.customerEmail }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="modal-footer">
                <button class="btn btn-secondary" data-dismiss="modal">{{ 'Buttons.Close' | translate }}</button>
            </div>
        </div>
    </div>
</div>